
import Vue from 'vue'
function createNode(txt) {
    let tempNode = document.createElement('div');
    tempNode.innerHTML = txt;
    return tempNode.firstChild;
 }
Vue.prototype.wh8alert = function (content){
    var dom='<div class="pop_wh8_alert" >\
        <div class="box">\
            <div id="close" class="close_btn closefun" ></div>\
            <div class="title"><img>提示</div>\
            <div class="wrap">\
                <pre id="alert_content" style="white-space: pre-line;text-align: justify;"></pre>\
                <button class="roger closefun">确定</button>\
            </div>\
        </div>\
    </div>'
    var app = document.querySelector("body");
    app.appendChild(createNode(dom))
    document.querySelector('#alert_content').innerHTML=content
    const buttons = document.querySelectorAll(".closefun")
    for (const button of buttons) {
    button.onclick=
    function(){
        let s=document.querySelector(".pop_wh8_alert");
        s.remove()
    };
    }
}
